import { StopNew } from "../../../ducks/data/route-with-stops/types";
import { useTranslation } from "react-i18next";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

const StopNote = ({ stop }: { stop: StopNew }) => {
  const { t } = useTranslation(["translation"]);

  if (!stop.note) {
    return null;
  }

  return (
    <div className="stop-component">
      <ChatBubbleIcon
        style={{ fontSize: 20, width: 24 }}
        className="stop-component-icon"
      />
      <div className="flex-grow">
        {t("translation:noteForDriver")}: {stop.note}
      </div>
    </div>
  );
};

export default StopNote;
